export default "/images/bitcoin__qr_code.png";